import { DELETE_CONFIRMATION_DIALOG_LABELS } from './DeleteConfirmationDialog.labels';

export const TITLE_BY_ENTITY: Record<'session' | 'test', string> = {
	session: DELETE_CONFIRMATION_DIALOG_LABELS.TITLE_SESSION,
	test: DELETE_CONFIRMATION_DIALOG_LABELS.TITLE_TEST
};

export const CONFIRM_LABEL_BY_ENTITY: Record<'session' | 'test', string> = {
	session: DELETE_CONFIRMATION_DIALOG_LABELS.CONFIRM_SESSION,
	test: DELETE_CONFIRMATION_DIALOG_LABELS.CONFIRM_TEST
};
